import React, { createContext, useReducer, useState } from 'react'
import { UserReducer } from './UserReducer'

import {
  ADD_USER,
  apiUrl,
  USERS_LOADED_SUCCESS,
  ADD_USER_FAIL,
  USERS_LOADED_FAIL,
  USER_LOADED_SUCCESS,
  USER_LOADED_FAIL,
  UPDATE_USER_FAIL,
  UPDATE_USER,
  DELETE_USER
} from '../constants/constants'
import axios from 'axios'
export const UserContext = createContext()

const UserContextProvider = ({ children }) => {
  const [userState, dispatch] = useReducer(UserReducer, {
    user: null,
    users: [],
    usersLoading: true,
    addUserStatus: false,
    status: false
  })

  const [showToast, setShowToast] = useState({
    show: false,
    message: '',
    type: null
  })

  //get user
  const getUser = async (id) => {
    try {
      const res = await axios.get(`${apiUrl}/user/find/${id}`, {
        headers: {
          token:
            'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
        }
      })

      if (res.data.success) {
        userState.status = true
        dispatch({ type: USER_LOADED_SUCCESS, payload: res.data.info })
      }
    } catch (error) {
      dispatch({ type: USER_LOADED_FAIL })
    }
  }

  //get movies

  const getUsers = async () => {
    try {
      const res = await axios.get(`${apiUrl}/user/`, {
        headers: {
          token:
            'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
        }
      })

      if (res.data.success) {
        dispatch({ type: USERS_LOADED_SUCCESS, payload: res.data.users })
      }
    } catch (error) {
      dispatch({ type: USERS_LOADED_FAIL })
    }
  }

  //add post
  const addUser = async (newUser) => {
    try {
      const response = await axios.post(`${apiUrl}/users/`, newUser)

      if (response.data.success) {
        dispatch({ type: ADD_USER })
        return
      }
    } catch (error) {
      dispatch({ type: ADD_USER_FAIL })
    }
  }

  //update user
  const updateUser = async (id, newUser) => {
    try {
      const hUser = {
        email: newUser.email,
        password: newUser.password,
        isAdmin: newUser.isAdmin,
        name: newUser.fullName
      }

      const response = await axios.put(`${apiUrl}/user/${id}`, hUser, {
        headers: {
          token:
            'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
        }
      })
      console.log(response)
      if (response.data.success) {
        dispatch({ type: UPDATE_USER })
        return response.data
      }
    } catch (error) {
      return error.response.data
      dispatch({ type: UPDATE_USER_FAIL })
    }
  }

  //delete user

  const deleteUser = async (userId) => {
    try {
      const response = await axios.delete(`${apiUrl}/user/${userId}`, {
        headers: {
          token:
            'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
        }
      })
      if (response.data.success) {
        dispatch({ type: DELETE_USER, payload: userId })
        return response.data
      }
    } catch (error) {
      console.log(error)
    }
  }

  //context data
  const UserContextData = {
    userState,
    addUser,
    getUsers,
    getUser,
    updateUser,
    showToast,
    setShowToast,
    deleteUser
    // addTodo,
    // deleteTodo,
  }
  return (
    <UserContext.Provider value={UserContextData}>
      {children}
    </UserContext.Provider>
  )
}

export default UserContextProvider
